// Lib
import React, { MutableRefObject } from 'react';
import Handsontable from 'handsontable';
import { getElementId, getTableContent } from '../../../common/elements/utils/elementPropertyUtils';
import { useHotTableDataV2 } from './dataConversion/useHotTableDataV2';
import HotTable from './HotTable';
import LegacyHotTable from './legacy/HotTable';
import { TranslationFunction } from '../../components/i18n/types';
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { registerHotPlugins } from './hotPluginsRegistration';
import { useSelector } from 'react-redux';
import { userLanguagePreferenceSelector } from '../../user/currentUserSelector';

import './HotTableSwitch.scss';

// Register the plugins once globally
// TODO-TABLES - This can be moved to HotTable when the legacy implementation is removed
registerHotPlugins();

type HotTableSwitchProps = {
    element: ImMNElement;
    hotTableInstanceRef: MutableRefObject<Handsontable | null>;
    showTitle: boolean;
    showCaption: boolean;
    isReadOnly: boolean;
    translateTableContextMenu: TranslationFunction;
    // TODO-TABLES - These are legacy only props and can be removed when the legacy table is deprecated
    isGridMoving: boolean;
    setIsGridMoving: (isMoving: boolean) => void;
};

const HotTableSwitch: React.FC<HotTableSwitchProps> = (props) => {
    const { element } = props;

    const locale = useSelector(userLanguagePreferenceSelector);
    const elementId = getElementId(element);
    const tableContent = getTableContent(element);
    const tableContentDataV2 = useHotTableDataV2(tableContent, locale, elementId);

    if (tableContentDataV2) return <HotTable {...props} locale={locale} tableContentData={tableContentDataV2} />;

    return <LegacyHotTable {...props} />;
};

export default HotTableSwitch;
